import type { ComponentSchema } from '../../../../../schema-types'
import { schema as shared } from '../../../../lightings/lightings-1/sections/product/product-detail.schema'

/**
 * Projukti product page: the shared fields plus a "How to order" tab, the delivery areas table, the "Related
 * products" column and the spec-table groups.
 */
export const schema: ComponentSchema = {
  ...shared,
  commonFields: [
    ...shared.commonFields,
    { key: 'howToOrderTitle', label: '"How to order" tab title', type: 'string', default: 'How to order' },
    { key: 'howToOrder', label: 'How to order', type: 'localized-text', help: 'Steps shown in their own tab; the tab is hidden while this is empty.' },
    { key: 'showDeliveryAreas', label: 'Show delivery areas and charges', type: 'boolean', default: true },
    { key: 'showRelated', label: 'Show related products', type: 'boolean', default: true, help: 'A column left of the product on computers, under the tabs on phones.' },
    { key: 'relatedTitle', label: 'Related products title', type: 'string', default: 'Related products', dependency: { field: 'showRelated', value: true } },
    {
      key: 'specGroups',
      label: 'Spec groups',
      type: 'array',
      help: 'Your own headings for the specification table. Empty = Processor, Memory, Storage, Graphics, Display, Connectivity, Physical, Power, Warranty; anything unmatched goes under General.',
      itemSchema: [
        { key: 'title', label: 'Heading', type: 'string', placeholder: 'Processor' },
        { key: 'attributes', label: 'Attribute names', type: 'string', placeholder: 'Processor, Cores, Threads', help: 'Comma-separated, as they are named in your attributes.' },
      ],
    },
  ],
}
